import { Table as Table$1 } from './Table.js';
import { Body } from './Body.js';
import { Cell } from './Cell.js';
import { Caption } from './Caption.js';
import { Head } from './Head/Head.js';
import { Row } from './Row/Row.js';

var Table = Table$1;
Table.Body = Body;
Table.Cell = Cell;
Table.Head = Head;
Table.Row = Row;
Table.Caption = Caption;
Table.Body.displayName = 'Table.Body';
Table.Cell.displayName = 'Table.Cell';
Table.Head.displayName = 'Table.Head';
Table.Row.displayName = 'Table.Row';
Table.Caption.displayName = 'Table.Caption';

export { Table };
